import styled from 'styled-components';
import { Card } from 'lib/components/Card/Card';

export const StyledMachineRobotStatus = styled(Card)`
  border: 2px solid ${(props): string => props.theme.kcc.colors.GRAY_100};
  border-radius: ${(props): number => props.theme.kcc.borderRadius.OVERLAYS}px;

  &.ant-card-bordered {
    border: 2px solid ${(props): string => props.theme.kcc.colors.GRAY_100};
  }

  .ant-card-head {
    background-color: ${(props): string => props.theme.kcc.colors.GRAY_100};
    padding: ${(props): string => props.theme.kcc.spacing.BASE} ${(props): string => props.theme.kcc.spacing.LG};
    border-bottom: none;
    min-height: unset;
    .ant-card-head-wrapper {
      height: unset;
      .ant-card-head-title {
        h3 {
          ${(props): string => props.theme.fontStyles.redesign.xl.strong}
          font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
          font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
          text-transform: none;
          margin: 0;
        }
      }
    }
  }

  .ant-card-body {
    height: 100%;
    padding: ${(props): string => props.theme.kcc.spacing.BASE} ${(props): string => props.theme.kcc.spacing.LG};
  }

  .machine-robot-status__info-wrapper {
    display: flex;
    flex-direction: column;
    gap: ${(props): string => props.theme.kcc.spacing.SM};
  }

  &.machine-robot-status--loading .machine-robot-status__info-wrapper {
    gap: ${(props): string => props.theme.kcc.spacing.LG};
  }

  .machine-robot-status__routine-wrapper > div {
    margin-bottom: 0;
  }

  .machine-robot-status__cleaning-status {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${(props): string => props.theme.kcc.spacing.SM};
  }

  .machine-robot-status__cleaning-map-name > * {
    align-items: center;
    width: fit-content;
    height: 24px;
    margin: 0;
    padding: 0 ${(props): string => props.theme.kcc.spacing.SM};
    background-color: rgba(0, 110, 228, 1);
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.SM}px;
    line-height: 24px;
  }

  .machine-robot-status__route-group {
    display: flex;
    flex-direction: column;
    gap: ${(props): string => props.theme.kcc.spacing.XXS};
  }

  .machine-robot-status__power-wrapper {
    gap: ${(props): string => props.theme.kcc.spacing.LG};
  }

  &.machine-robot-status {
    .machine-robot-status__routine-wrapper,
    .machine-robot-status__progress-wrapper {
      .ant-progress-outer,
      .ant-progress-inner,
      .ant-progress-bg,
      .ant-progress-steps-item {
        height: 8px !important;
      }
    }
  }
`;
